import i18n from "@/lang";
import AppModule from "@/store/modules/app";
import AuthModule from "@/store/modules/auth";
import CashFloatModule from "@/store/modules/cash-float";
import { redirectToLoginPage } from "@/utils/helpers/router.helper";
import { hasNonEmptyBookings } from "@/utils/vue-helpers/booking";
import { closeSales } from "@/utils/vue-helpers/cash-float";
import { ElMessageBox } from "element-plus";
import { defineComponent } from "vue";
export default defineComponent({
  name: "ConfirmLogout",
  setup: function setup() {
    // const { t } = useI18n({});
    var t = i18n.global.t; // let t = null;

    var confirmLogout = function confirmLogout() {
      ElMessageBox.close();
      AuthModule.UserLogOut(); // remove gId parameter if it is set

      if (AppModule.gid) {
        AppModule.removeGID();
      } // discard closing cashfloat page


      if (CashFloatModule.isClosingCashfloat) {
        CashFloatModule.setIsClosingCashfloat(false);
      }

      redirectToLoginPage();
    };

    var cancelLogout = function cancelLogout() {
      ElMessageBox.close();
    };

    return {
      cancelLogout: cancelLogout,
      closeSales: closeSales,
      t: t,
      confirmLogout: confirmLogout,
      hasNonEmptyBookings: hasNonEmptyBookings
    };
  }
});